import script from "./TableManage.vue?vue&type=script&setup=true&lang=js"
export * from "./TableManage.vue?vue&type=script&setup=true&lang=js"

import "./TableManage.vue?vue&type=style&index=0&id=6bf598b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bf598b1"]])

export default __exports__